import Vue from 'vue'
import VueRouter from 'vue-router'
import VueMeta from 'vue-meta'
import NProgress from 'nprogress/nprogress'
import routes, { AMAZON_CONNECT_ARTICLE_ID } from './routes'

Vue.use(VueRouter)
// keyName: the component option vue-meta reads meta from.
Vue.use(VueMeta, { keyName: 'page' })

const router = new VueRouter({
  routes,
  // Hash mode; 'history' is off because it needs server config.
  // mode: 'history',
  // Restore saved scroll position, otherwise go to top.
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
})

// Catches name-based navigation to the configured article id (the static route
// only matches URL hits); redirects it to the dedicated book-request view.
router.beforeEach((routeTo, routeFrom, next) => {
  if (
    AMAZON_CONNECT_ARTICLE_ID &&
    routeTo.name !== 'book-request-ac' &&
    routeTo.params.articleId === AMAZON_CONNECT_ARTICLE_ID
  ) {
    next({ name: 'book-request-ac', query: routeTo.query })
    return
  }
  next()
})

// Progress bar: start on non-initial navigations, finish when done.
router.beforeResolve((routeTo, routeFrom, next) => {
  if (routeFrom.name) {
    NProgress.start()
  }
  next()
})

router.afterEach((routeTo, routeFrom) => {
  NProgress.done()
})

export default router
